export const OPEN_TAB_API_REQUEST = 'OPEN_TAB_API_REQUEST';
export const OPEN_TAB_API_SUCCESS = 'OPEN_TAB_API_SUCCESS';
export const OPEN_LOW_VIS_TAB_API_SUCCESS = 'OPEN_LOW_VIS_TAB_API_SUCCESS';
export const OPEN_LOW_VIS_TAB_API_FIRST_LOAD_SUCCESS = 'OPEN_LOW_VIS_TAB_API_FIRST_LOAD_SUCCESS';
export const OPEN_TAB_API_ERROR = 'OPEN_TAB_API_ERROR';
export const AD_SERVICE_API_REQUEST = 'AD_SERVICE_API_REQUEST';
export const AD_SERVICE_API_SUCCESS = 'AD_SERVICE_API_SUCCESS';
export const AD_SERVICE_API_ERROR = 'AD_SERVICE_API_ERROR';
export const BATCH_API_REQUEST = 'BATCH_API_REQUEST';
export const BATCH_API_NEXT = 'BATCH_API_NEXT';
export const BATCH_API_SUCCESS = 'BATCH_API_SUCCESS';
export const INFO_API_REQUEST = 'INFO_API_REQUEST';
export const INFO_API_SUCCESS = 'INFO_API_SUCCESS';
export const INFO_API_ERROR = 'INFO_API_ERROR';
export const CREDIT_API_REQUEST = 'CREDIT_API_REQUEST';
export const CREDIT_API_SUCCESS = 'CREDIT_API_SUCCESS';
export const CREDIT_API_ERROR = 'CREDIT_API_ERROR';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_AUTH_FAILED = 'SET_AUTH_FAILED';
export const UPDATE_SELECTED = 'UPDATE_SELECTED';
export const UPDATE_PREMIUM_CHECKED = 'UPDATE_PREMIUM_CHECKED';
export const UPDATE_KEY_VALUE = 'UPDATE_KEY_VALUE';
export const TRANSACTION_API_ERROR = 'TRANSACTION_API_ERROR';
export const CREDIT_PLANS_GET_API_SUCCESS = 'CREDIT_PLANS_GET_API_SUCCESS';
export const CREDIT_PLANS_PAYMENT_METHOD_GET_SUCCESS = 'CREDIT_PLANS_PAYMENT_METHOD_GET_SUCCESS';
export const GALLERY_GET_API_REQUEST = 'GALLERY_GETIMAGES_API_REQUEST';
export const GALLERY_GET_API_SUCCESS = 'GALLERY_GETIMAGES_API_SUCCESS';
export const GALLERY_SET_IMAGES = 'GALLERY_SET_IMAGES';
export const GALLERY_GET_API_ERROR = 'GALLERY_GET_API_ERROR';
export const GALLERY_POST_API_REQUEST = 'GALLERY_POST_API_REQUEST';
export const GALLERY_POST_API_COMPLETED = 'GALLERY_POST_API_COMPLETED';
export const GALLERY_POST_API_SUCCESS = 'GALLERY_POST_API_SUCCESS';
export const GALLERY_POST_API_ERROR = 'GALLERY_POST_API_ERROR';
export const GALLERY_POST_API_PROGRESS = 'GALLERY_POST_API_PROGRESS';
export const GALLERY_DELETE_API_SUCCESS = 'GALLERY_DELETE_API_SUCCESS';
export const GALLERY_DELETE_API_ERROR = 'GALLERY_DELETE_API_ERROR';
export const GALLERY_DELETE_API_REQUEST = 'GALLERY_DELETE_API_REQUEST';
export const CHANGE_PLAN_API_REQUEST = 'CHANGE_PLAN_API_REQUEST';
export const CHANGE_PLAN_API_SUCCESS = 'CHANGE_PLAN_API_SUCCESS';
export const CHANGE_PLAN_API_ERROR = 'CHANGE_PLAN_API_ERROR';
export const GAMIFICATION_API_REQUEST = 'GAMIFICATION_API_REQUEST';
export const GAMIFICATION_API_SUCCESS = 'GAMIFICATION_API_SUCCESS';
export const GAMIFICATION_API_ERROR = 'GAMIFICATION_API_ERROR';
export const SET_ADROW_LOADING = 'SET_ADROW_LOADING';
export const AD_STATS_API_REQUEST = 'AD_STATS_API_REQUEST';
export const AD_STATS_API_SUCCESS = 'AD_STATS_API_SUCCESS';
export const AD_STATS_API_ERROR = 'AD_STATS_API_ERROR';
export const STOREUSERS_API_REQUEST = 'STOREUSERS_API_REQUEST';
export const STOREUSERS_API_COMPLETE = 'STOREUSERS_API_COMPLETE';
export const STOREUSERS_GET_API_SUCCESS = 'STOREUSERS_GET_API_SUCCESS';
export const STOREUSERS_UPDATE_API_SUCCESS = 'STOREUSERS_UPDATE_API_SUCCESS';
export const STOREUSERS_DELETE_API_SUCCESS = 'STOREUSERS_DELETE_API_SUCCESS';
export const STOREUSERS_API_SET_MESSAGE = 'STOREUSERS_API_SET_MESSAGE';
export const STOREUSERS_SELECT_USER = 'STOREUSERS_SELECT_USER';
export const PURCHASE_CREDITS = 'PURCHASE_CREDITS';
export const PURCHASE_CREDITS_SUCCESS = 'PURCHASE_CREDITS_SUCCESS';
export const PURCHASE_CREDITS_ERROR = 'PURCHASE_CREDITS_ERROR';
export const PAYMENT_RESULT_REQUEST = 'PAYMENT_RESULT_REQUEST';
export const PAYMENT_RESULT_SUCCESS = 'PAYMENT_RESULT_SUCCESS';
export const PAYMENT_RESULT_ERROR = 'PAYMENT_RESULT_ERROR';
export const GET_CREDIT_BALANCE_REQUEST = 'GET_CREDIT_BALANCE_REQUEST';
export const GET_CREDIT_BALANCE_SUCCESS = 'GET_CREDIT_BALANCE_SUCCESS';
export const GET_CREDIT_BALANCE_ERROR = 'GET_CREDIT_BALANCE_ERROR';
export const GET_PROFILE_FROM_HEADER = 'GET_PROFILE_FROM_HEADER';
